import {ActivityEvent} from '../types';

const STORAGE_KEY = 'pac-activity-events';
const MAX_EVENTS = 100;

export const ActivityEventsService = {
    fetchAll: async (): Promise<ActivityEvent[]> => {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    },

    add: async (action: string, details?: string, userId?: string): Promise<ActivityEvent> => {
        const events = await ActivityEventsService.fetchAll();
        const newEvent: ActivityEvent = {
            id: Date.now().toString(),
            action,
            timestamp: new Date().toISOString(),
            details,
            userId
        };
        events.unshift(newEvent);
        
        const trimmedEvents = events.slice(0, MAX_EVENTS);
        
        localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmedEvents));
        return newEvent;
    },

    clear: async (): Promise<void> => {
        localStorage.removeItem(STORAGE_KEY);
    }
};
